const LOCAL_TEST_SITE_KEY = "1x00000000000000000000AA";
const PRODUCTION_SITE_KEY = "0x4AAAAAAFk3Xjkpt1qyzcrG";

export const registrationSiteKey = (hostname, configuredKey) =>
  ["localhost", "127.0.0.1"].includes(hostname)
    ? LOCAL_TEST_SITE_KEY
    : hostname === "help.edu.gov.af" ? configuredKey || PRODUCTION_SITE_KEY : "";
